<template>
  <!-- Toggle between all products and new products only -->
  <v-btn-toggle :model-value="selectedView" mandatory @update:model-value="updateView">
    <v-btn :value="getFilteredProductsViewValue">
      {{ getFilteredProductsTitle }}
    </v-btn>
    <v-btn class="border-s-thin border-e-thin" :value="'forAssortment'">
      {{ tkey('forAssortment') }}
    </v-btn>
    <v-btn :value="'allProducts'">
      {{ tkey('allProducts') }}
    </v-btn>
  </v-btn-toggle>
</template>

<script setup>
import { computed, defineEmits } from 'vue';
import { useInternationalization } from '@/composables/use-internationalization';

const props = defineProps({
  selectedView: String,
  productModellingViewsToggleType: String,
});

const emit = defineEmits(['update-view']);
const { tkey } = useInternationalization('productModellingPage');

const getFilteredProductsTitle = computed(() => {
  switch (props.productModellingViewsToggleType) {
    case 'new':
      return tkey('newProductsOnly');
    case 'nonEstablished':
      return tkey('nonEstablishedProducts');
    default:
      return tkey('newProductsOnly');
  }
});

const getFilteredProductsViewValue = computed(() => {
  switch (props.productModellingViewsToggleType) {
    case 'new':
      return 'newProductsOnly';
    case 'nonEstablished':
      return 'nonEstablishedProductsOnly';
    default:
      return 'newProductsOnly';
  }
});

const updateView = value => {
  emit('update-view', value);
};
</script>
